import React, { useState, useEffect } from "react";
import { checkResult, createFilePath, createSelectOption } from "@/common";
import { useWatchState } from "@/store";
import { BaseService, } from "@/service";
import { Modal, message, Divider, Card, Button, Collapse, Form, Col, Row, Input, Select } from "antd";
import moment from "moment";

const NAME = "projectEditRec";

const App = () => {

    const add_date = parseInt(new Date().getTime() / 1000);
    const [loading, setLoading] = useState(false);
    const [[IS_REGION], [{ IS_LOGIN, info }]] = useWatchState(["IS_REGION", "user",]);
    const [[modalProps]] = useWatchState(["modal." + NAME])
    const { title = "", show, hide, width = 1000, DetailId, expertId, orgId, contrast, callback } = modalProps;
    const [projectData, setProjectData] = useState([]);
    const [comment, setComment] = useState('');
    const [original, setOriginal] = useState(0);
    const [innovate, setInnovate] = useState(0);
    const [core, setCore] = useState(0);
    const [tradition, setTradition] = useState(0);
    const [develop, setDevelop] = useState(0);
    const [strategy, setStrategy] = useState(0);
    const [realize, setRealize] = useState(0);
    const [market, setMarket] = useState(0);
    const [profit, setProfit] = useState(0);
    const [target_market, setTarget_market] = useState(0);
    const [promote, setPromote] = useState(0);
    const [life_cycle, setLife_cycle] = useState(0);
    const [investment_heat, setInvestment_heat] = useState(0);
    const [team_operations, setTeam_operations] = useState(0);
    const [implementation_risk, setImplementation_risk] = useState(0);
    const [generality, setGenerality] = useState(0);
    const [resources, setResources] = useState(0);
    const [prepare, setPrepare] = useState(0);
    const [recommend_type, setRecommend_type] = useState(0);
    const { Option, OptGroup } = Select;
    const InputGroup = Input.Group;
    const { TextArea } = Input;
    const roc_org = (
        (orgId) ? (orgId) : expertId
    )

    useEffect(() => {
        if (DetailId) projectShow(DetailId)
    }, [DetailId])

    const projectShow = (project_id) => {
        BaseService.list({
            table: "thtt_project",
            columns: "id,name,org_name,orgRec_id,personRec_id",
            where: {
                "id": project_id,
                "is_delete": 0,
            },
        }).then(res => {
            if (!checkResult(res)) return;
            setProjectData(res.data.result[0]);
        })
    }

    const onSubmit = async (e) => {
        e.preventDefault();
        if (!comment) return message.error("请填写成果简要评语");

        const update_date = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
        setLoading(true);
        // 先判断是否已经提交过推荐意见了
        const res = await BaseService.list({
            table: "thtt_project_rec_opinion",
            where: {
                project_id: DetailId, is_delete: 0,
                ...((orgId) ? { roc_org: projectData.orgRec_id } : (expertId ? { roc_org: projectData.personRec_id } : ''))
            }
        })
        if (res.data.result.length) return message.warn("您已经为该成果填写过推荐意见了，无需重复提交！")

        const addRes = await BaseService.add({
            table: "thtt_project_rec_opinion",
            data: { original, innovate, core, tradition, develop, strategy, realize, market, profit, target_market, promote, life_cycle, investment_heat, team_operations, implementation_risk, generality, resources, prepare, comment, recommend_type, project_id: DetailId, roc_org: roc_org, add_date: add_date, update_date: update_date, is_delete: 0 }
        }).then(res => {
            if (res.data.result) {
                BaseService.put({
                    table: "thtt_project",
                    data: {
                        recommend_state: 1,
                        recommend_date: update_date,
                        report_type: recommend_type,
                    },
                    where: { "id": DetailId }
                })
            }
            setLoading(false)
            if (res.data.status !== 200) {
                message.error(res.data.msg);
                return;
            }
            message.success("您的推荐意见已经提交成功");
            hide();
            if (callback) callback();
        })
    }

    return (
        <Modal
            visible={show}
            width={width}
            maskClosable={false}
            destroyOnClose
            onCancel={hide}
            footer={false}
        >
            <Form>
                <h3 style={{ textAlign: "center" }}>中华国际科技交流基金会</h3>
                <h3 style={{ textAlign: "center" }}>“双推双促工程”新动能科技成果</h3>
                <h3 style={{ textAlign: "center" }}>入围成果推荐意见书</h3>
                <Row gutter={24} type="flex" style={{ marginTop: 20, height: 30 }}>
                    <div style={{ textAlign: "left", marginLeft: 10, display: "inline-block" }}>申报成果名称：{projectData.name}</div>
                    <div style={{ textAlign: "right", float: "right", marginLeft: 50 }}>申报单位：{projectData.org_name}</div>
                </Row>
                <Row gutter={24} type="flex">
                    <Card title="高技术价值" style={{ width: 960, height: 140, marginLeft: 10 }}>
                        <Col span={8} >
                            <Form.Item label="自主原创重大技术成果" type="flex">
                                <Select placeholder="请选择" onChange={e => setOriginal(e)} style={{ width: "90px" }}>
                                    <Option value="1">符合</Option>
                                    <Option value="2">一般</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={8} >
                            <Form.Item label="前沿引领创新技术成果" type="flex">
                                <Select placeholder="请选择" onChange={e => setInnovate(e)} style={{ width: "90px" }}>
                                    <Option value="1">符合</Option>
                                    <Option value="2">一般</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={8} >
                            <Form.Item label="产业关键核心技术成果" type="flex">
                                <Select placeholder="请选择" onChange={e => setCore(e)} style={{ width: "90px" }}>
                                    <Option value="1">符合</Option>
                                    <Option value="2">一般</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Card>
                </Row>
                <Row gutter={24} type="flex" style={{ marginTop: 20 }}>
                    <Card title="高产业价值" style={{ width: 960, height: 140, marginLeft: 10 }}>
                        <Col span={8} >
                            <Form.Item label="助力传统产业转型升级" type="flex">
                                <Select placeholder="请选择" onChange={e => setTradition(e)} style={{ width: "90px" }}>
                                    <Option value="1">符合</Option>
                                    <Option value="2">一般</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={8} >
                            <Form.Item label="支撑战略新兴产业发展" type="flex">
                                <Select placeholder="请选择" onChange={e => setDevelop(e)} style={{ width: "90px" }}>
                                    <Option value="1">符合</Option>
                                    <Option value="2">一般</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={8} >
                            <Form.Item label="发挥未来产业定位方向" type="flex">
                                <Select placeholder="请选择" onChange={e => setStrategy(e)} style={{ width: "90px" }}>
                                    <Option value="1">符合</Option>
                                    <Option value="2">一般</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Card>
                </Row>
                <Row gutter={24} type="flex" style={{ marginTop: 20 }}>
                    <Card title="高经济价值" style={{ width: 960, height: 140, marginLeft: 10 }}>
                        <Col span={8} >
                            <Form.Item label="项目已实现营收规模大" type="flex">
                                <Select placeholder="请选择" onChange={e => setRealize(e)} style={{ width: "90px" }}>
                                    <Option value="1">符合</Option>
                                    <Option value="2">一般</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={8} >
                            <Form.Item label="项目对地区经济贡献大" type="flex">
                                <Select placeholder="请选择" onChange={e => setMarket(e)} style={{ width: "90px" }}>
                                    <Option value="1">符合</Option>
                                    <Option value="2">一般</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={8} >
                            <Form.Item label="项目可实现效益预期大" type="flex">
                                <Select placeholder="请选择" onChange={e => setProfit(e)} style={{ width: "90px" }}>
                                    <Option value="1">符合</Option>
                                    <Option value="2">一般</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Card>
                </Row>
                <Row gutter={24} type="flex" style={{ marginTop: 20 }}>
                    <Card title="高市场价值" style={{ width: 960, height: 140, marginLeft: 10 }}>
                        <Col span={8} >
                            <Form.Item label="成果目标市场规模巨大" type="flex">
                                <Select placeholder="请选择" onChange={e => setTarget_market(e)} style={{ width: "90px" }}>
                                    <Option value="1">符合</Option>
                                    <Option value="2">一般</Option>
                                </Select>
                            </Form.Item></Col>
                        <Col span={8} >
                            <Form.Item label="成果推广应用场景多元" type="flex">
                                <Select placeholder="请选择" onChange={e => setPromote(e)} style={{ width: "90px" }}>
                                    <Option value="1">符合</Option>
                                    <Option value="2">一般</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={8} >
                            <Form.Item label="成果市场生命周期可见" type="flex">
                                <Select placeholder="请选择" onChange={e => setLife_cycle(e)} style={{ width: "90px" }}>
                                    <Option value="1">符合</Option>
                                    <Option value="2">一般</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Card>
                </Row>
                <Row gutter={24} type="flex" style={{ marginTop: 20 }}>
                    <Card title="高资本价值" style={{ width: 960, height: 140, marginLeft: 10 }}>
                        <Col span={8} >
                            <Form.Item label="项目方向投资热度较高" type="flex">
                                <Select placeholder="请选择" onChange={e => setInvestment_heat(e)} style={{ width: "90px" }}>
                                    <Option value="1">符合</Option>
                                    <Option value="2">一般</Option>
                                </Select>
                            </Form.Item></Col>
                        <Col span={8} >
                            <Form.Item label="项目团队运作能力较强" type="flex">
                                <Select placeholder="请选择" onChange={e => setTeam_operations(e)} style={{ width: "90px" }}>
                                    <Option value="1">符合</Option>
                                    <Option value="2">一般</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={8} >
                            <Form.Item label="项目实施风险防控可信" type="flex">
                                <Select placeholder="请选择" onChange={e => setImplementation_risk(e)} style={{ width: "90px" }}>
                                    <Option value="1">符合</Option>
                                    <Option value="2">一般</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Card>
                </Row>
                <Row gutter={24} type="flex" style={{ marginTop: 20 }}>
                    <Card title="高转化价值" style={{ width: 960, height: 140, marginLeft: 10 }}>
                        <Col span={8} >
                            <Form.Item label="主体企业创新能力到位" type="flex">
                                <Select placeholder="请选择" onChange={e => setGenerality(e)} style={{ width: "90px" }}>
                                    <Option value="1">符合</Option>
                                    <Option value="2">一般</Option>
                                </Select>
                            </Form.Item></Col>
                        <Col span={8} >
                            <Form.Item label="成果转化资源要素到位" type="flex">
                                <Select placeholder="请选择" onChange={e => setResources(e)} style={{ width: "90px" }}>
                                    <Option value="1">符合</Option>
                                    <Option value="2">一般</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={8} >
                            <Form.Item label="成果转化落地进程到位" type="flex">
                                <Select placeholder="请选择" onChange={e => setPrepare(e)} style={{ width: "90px" }}>
                                    <Option value="1">符合</Option>
                                    <Option value="2">一般</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Card>
                </Row>
                {/*
                <Divider>成果推荐意见</Divider>
                <Form.Item label="*推荐类型选项" type="flex">
                    <Select placeholder="请选择" onChange={e => setRecommend_type(e)} style={{ width: "160px" }}>
                        <Option value="1">领航项目</Option>
                        <Option value="2">启航项目</Option>
                        <Option value="3">备航项目</Option>
                    </Select>
                </Form.Item>
                */}
                <Form.Item label="*对该成果简要评语">
                    <TextArea rows={6} placeholder="核心技术（所属产业领域/核心主打产品/主要业务模式/整体营销规模/所在行业单位）/应用场景" onChange={e => setComment(e.target.value)}>
                    </TextArea>
                </Form.Item>
                <div className="flex hor child-left-xl m-md-t">
                    <Button type="primary" onClick={onSubmit}>提交</Button>
                    <Button onClick={hide}>取消</Button>
                </div>
            </Form>
        </Modal>
    );
}

export default App;